<aiops-agent-header
  [logoSrc]="'eda-logo.png'"
  [headerTheme]="'dark'"
  [menuItems]="headerMenuItems"
  [sidebarToggleEnabled]="true"
>
  <ng-container general>
    <p-menu #menu [model]="items" [popup]="true" appendTo="body" />
    <a
      class="menu-link d-flex-center mr-4"
      (click)="startNewChat()"
      [attr.title]="'MAIN.ACTIONS.NEW_CHAT' | translate"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
      >
        <path
          d="M16.6667 1.66667C16.6667 0.75 15.9167 0 15 0H1.66667C0.75 0 0 0.75 0 1.66667V11.6667C0 12.5833 0.75 13.3333 1.66667 13.3333H13.3333L16.6667 16.6667V1.66667ZM15 12.6417L14.025 11.6667H1.66667V1.66667H15V12.6417ZM9.16667 2.5H7.5V5.83333H4.16667V7.5H7.5V10.8333H9.16667V7.5H12.5V5.83333H9.16667V2.5Z"
          fill="currentColor"
        />
      </svg>
    </a>
    <a
      class="menu-link d-flex-center mr-4"
      href="javascript:void(0)"
      [attr.title]="'MAIN.ACTIONS.VERIFIED' | translate"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 0.833313L2.5 4.16665V9.16665C2.5 13.7916 5.7 18.1166 10 19.1666C14.3 18.1166 17.5 13.7916 17.5 9.16665V4.16665L10 0.833313ZM15.8333 9.16665C15.8333 12.9333 13.35 16.4083 10 17.4416C6.65 16.4083 4.16667 12.9333 4.16667 9.16665V5.24998L10 2.65831L15.8333 5.24998V9.16665ZM6.175 9.65831L5 10.8333L8.33333 14.1666L15 7.49998L13.825 6.31665L8.33333 11.8083L6.175 9.65831Z"
          fill="#33AF1C"
        />
      </svg>
    </a>
    <a
      class="menu-link d-flex-center"
      (click)="menu.toggle($event)"
      [attr.title]="'MAIN.ACTIONS.MORE' | translate"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M9.99967 6.66665C10.9163 6.66665 11.6663 5.91665 11.6663 4.99998C11.6663 4.08331 10.9163 3.33331 9.99967 3.33331C9.08301 3.33331 8.33301 4.08331 8.33301 4.99998C8.33301 5.91665 9.08301 6.66665 9.99967 6.66665ZM9.99967 8.33331C9.08301 8.33331 8.33301 9.08331 8.33301 9.99998C8.33301 10.9166 9.08301 11.6666 9.99967 11.6666C10.9163 11.6666 11.6663 10.9166 11.6663 9.99998C11.6663 9.08331 10.9163 8.33331 9.99967 8.33331ZM9.99967 13.3333C9.08301 13.3333 8.33301 14.0833 8.33301 15C8.33301 15.9166 9.08301 16.6666 9.99967 16.6666C10.9163 16.6666 11.6663 15.9166 11.6663 15C11.6663 14.0833 10.9163 13.3333 9.99967 13.3333Z"
          fill="white"
        />
      </svg>
    </a>
  </ng-container>

  <!--<ng-container sidebar>
        <aiops-sidebar [sidebarConfig]="sidebarConfig">
           <aiops-chat-history (conversationSelected)="onConversationSelected($event)"></aiops-chat-history>
        </aiops-sidebar>
    </ng-container>-->
</aiops-agent-header>
<div class="messager-wrapper">
  <aiops-messenger [selectedConversation]="selectedConversationSignal()"></aiops-messenger>
</div>

<aiops-about-dialog [(aboutVisible)]="showAboutDialog"></aiops-about-dialog>
<aiops-terms-of-use-dialog
  [(termsOfuseDialogVisible)]="showTermsOfUseDialog"
></aiops-terms-of-use-dialog>
